import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const CreateComplianceModalUI = ({ context, successMsg, errorList, setErrorList,
  createMode, submitted, onSubmit, onCancelClick,
  complianceCode, onComplianceCodeChange, complianceCodeError, setComplianceCodeError, complianceCodeList,
  clause, onClauseChange, clauseError, setClauseError, clauseCodeList,
  remarks, onRemarksChange, remarksError, setRemarksError,
  penaltyStatus, onPenaltyStatusChange, penaltyStatusError, setPenaltyStatusError, penaltyStatusList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Create Compliance'
    buttonLabel='Create'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF
      type='select' name='complianceCode' label='Compliance Code'
      value={complianceCode} onChange={onComplianceCodeChange} optionList={complianceCodeList}
      error={complianceCodeError} setError={setComplianceCodeError}
    />
    <InputSelectSF
      type='select' name='clause' label='Clause'
      value={clause} onChange={onClauseChange} optionList={clauseCodeList}
      error={clauseError} setError={setClauseError}
    />
    <InputTextSF
      type='text' name='remarks' label='Remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
    />
    <InputSelectSF
      type='select' name='penaltyStatus' label='Penalty Status'
      value={penaltyStatus} onChange={onPenaltyStatusChange} optionList={penaltyStatusList}
      error={penaltyStatusError} setError={setPenaltyStatusError}
    />

  </ModalFormUI>

export default CreateComplianceModalUI
